export default "__VITE_ASSET__hMab7xsx__"